import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useJourney } from '../context/JourneyContext';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { ArrowLeft, ShoppingBag, ExternalLink } from 'lucide-react';

// Official Let's Siva logo
const WHITE_LOGO = "https://customer-assets.emergentagent.com/job_dance-confidence/artifacts/00kbs5d6_Lets%20Siva_Final%20Logo_Black.png";

const MERCH_STORE_URL = "https://customteez.nz/collections/lets-siva-merch";

const Merch = () => {
  const navigate = useNavigate();
  const { trackPageView, trackCtaClick } = useJourney();

  React.useEffect(() => {
    trackPageView('merch');
  }, [trackPageView]);

  const handleShopClick = () => {
    trackCtaClick('shop_merch_external');
    window.open(MERCH_STORE_URL, '_blank');
  };

  return (
    <div 
      data-testid="merch-screen"
      className="min-h-screen relative overflow-hidden bg-[#1C1917]"
    >
      {/* Background */}
      <div className="absolute top-20 left-0 w-80 h-80 bg-ochre-400/5 rounded-full blur-3xl" />
      <div className="absolute bottom-20 right-0 w-72 h-72 bg-primary/5 rounded-full blur-3xl" />

      {/* Content */}
      <div className="relative z-10 max-w-3xl mx-auto px-6 py-12">
        {/* Navigation */}
        <Button
          data-testid="back-btn"
          variant="ghost"
          onClick={() => navigate(-1)}
          className="mb-8 text-stone-400 hover:text-white"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back
        </Button>

        {/* Header */}
        <div className="text-center mb-12 animate-fade-in-up">
          <img 
            src={WHITE_LOGO}
            alt="Let's Siva"
            className="h-12 mx-auto mb-4 object-contain"
          />
          <Badge className="mb-4 bg-ochre-400/20 text-ochre-400 border-ochre-400/30">
            Let's Siva Merch
          </Badge>
          <h1 
            data-testid="merch-title"
            className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold text-white mb-4"
          >
            Merch
          </h1>
        </div>

        {/* Main Card */}
        <Card className="bg-stone-900/80 border border-stone-800 p-8 md:p-12 text-center rounded-3xl animate-fade-in-up" style={{ animationDelay: '0.1s' }}>
          <ShoppingBag className="w-16 h-16 text-primary mx-auto mb-6" />
          
          <p className="text-lg text-stone-300 max-w-xl mx-auto mb-8">
            Our Let's Siva merch store is live through Custom Teez. Tap below to shop the full collection.
          </p>

          <Button
            data-testid="shop-merch-btn"
            onClick={handleShopClick}
            size="lg"
            className="rounded-full px-10 py-6 text-lg font-bold bg-primary hover:bg-primary/90 text-white transition-all duration-300 hover:scale-105"
          >
            Shop Let's Siva Merch
            <ExternalLink className="ml-2 w-5 h-5" />
          </Button>

          <p className="text-sm text-stone-500 mt-6">
            Merch is currently hosted through our partner Custom Teez.
          </p>
        </Card>
      </div>
    </div>
  );
};

export default Merch;
